<div class="rift-histogram-chart">
    <div [id]="'histogram-chart-' + register?.registerIndex + '-' + config?.Id">
    </div>
    <div *ngIf="noData === false && dataLoading === true" style="height: 420px" fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="noData === true" style="padding: 20px;">
        No data, please make sure that at least 2 histogram logging periods have passed.
    </div>
</div>